import { PatientFormType } from "../patients/EditPatientInfo";

export const EXAM_4PHOTOS_FULLNAME = "4 piani";
export const EXAM_4PHOTOS_SLUGNAME = "4foto";

export const EXAM_PODO_FULLNAME = "Podoscopio";
export const EXAM_PODO_SLUGNAME = "podo";

export const EXAM_PODO_STIM_FULLNAME = "Podoscopio Stimoli";
export const EXAM_PODO_STIM_SLUGNAME = "stim";

export const EXAM_AAII_FULLNAME = "Arti inferiori";
export const EXAM_AAII_SLUGNAME = "aaii";

export const EXAM_MAGNO_FULLNAME = "Stomatognatica";
export const EXAM_MAGNO_SLUGNAME = "magno";

export const EXAM_VISION_FULLNAME = "Visione";
export const EXAM_VISION_SLUGNAME = "vision";

export const EXAM_BALANCE_FULLNAME = "Bilancia";
export const EXAM_BALANCE_SLUGNAME = "bl";

export const EXAM_HEAD_FULLNAME = "Capo";
export const EXAM_HEAD_SLUGNAME = "capo";

export const EXAM_FUKUDA_FULLNAME = "Test di Fukuda";
export const EXAM_FUKUDA_SLUGNAME = "fukuda";

export const EXAM_ADAMS_FULLNAME = "Test di Adams";
export const EXAM_ADAMS_SLUGNAME = "adams";

export const EXAM_ROMBERG_FULLNAME = "Test di Romberg";
export const EXAM_ROMBERG_SLUGNAME = "romberg";

export const EXAM_RATE_FULLNAME = "Sommaria";
export const EXAM_RATE_SLUGNAME = "rate";

export const EXAM_ANAM_FULLNAME = "Anamnesi";
export const EXAM_ANAM_SLUGNAME = "anam";

export const EXAM_TINETTI_FULLNAME = "Tinetti Test";
export const EXAM_TINETTI_SLUGNAME = "Tinetti";

export const EXAM_ELICOIDALE_FULLNAME = "Test Policettivo";
export const EXAM_ELICOIDALE_SLUGNAME = "eli";

export const buildIdFilters = () => [];

export const buildExamTypeFilters = () => [
  { text: EXAM_4PHOTOS_FULLNAME, value: EXAM_4PHOTOS_SLUGNAME },
  { text: EXAM_AAII_FULLNAME, value: EXAM_AAII_SLUGNAME },
  { text: EXAM_PODO_FULLNAME, value: EXAM_PODO_SLUGNAME },
  { text: EXAM_PODO_STIM_FULLNAME, value: EXAM_PODO_STIM_SLUGNAME },
  { text: EXAM_MAGNO_FULLNAME, value: EXAM_MAGNO_SLUGNAME },
  { text: EXAM_VISION_FULLNAME, value: EXAM_VISION_SLUGNAME },
  { text: EXAM_BALANCE_FULLNAME, value: EXAM_BALANCE_SLUGNAME },
  { text: EXAM_HEAD_FULLNAME, value: EXAM_HEAD_SLUGNAME },
  { text: EXAM_FUKUDA_FULLNAME, value: EXAM_FUKUDA_SLUGNAME },
  { text: EXAM_ADAMS_FULLNAME, value: EXAM_ADAMS_SLUGNAME },
  { text: EXAM_ROMBERG_FULLNAME, value: EXAM_ROMBERG_SLUGNAME },
  { text: EXAM_RATE_FULLNAME, value: EXAM_RATE_SLUGNAME },
  { text: EXAM_ANAM_FULLNAME, value: EXAM_ANAM_SLUGNAME },
  { text: EXAM_TINETTI_FULLNAME, value: EXAM_TINETTI_SLUGNAME },

  { text: EXAM_ELICOIDALE_FULLNAME, value: EXAM_ELICOIDALE_SLUGNAME },
];

export const pexamTypeToFullname = (slugname: string) => {
  switch (slugname) {
    case EXAM_4PHOTOS_SLUGNAME:
      return EXAM_4PHOTOS_FULLNAME;
    case EXAM_PODO_SLUGNAME:
      return EXAM_PODO_FULLNAME;
    case EXAM_PODO_STIM_SLUGNAME:
      return EXAM_PODO_STIM_FULLNAME;
    case EXAM_AAII_SLUGNAME:
      return EXAM_AAII_FULLNAME;
    case EXAM_MAGNO_SLUGNAME:
      return EXAM_MAGNO_FULLNAME;
    case EXAM_VISION_SLUGNAME:
      return EXAM_VISION_FULLNAME;
    case EXAM_BALANCE_SLUGNAME:
      return EXAM_BALANCE_FULLNAME;
    case EXAM_HEAD_SLUGNAME:
      return EXAM_HEAD_FULLNAME;
    case EXAM_FUKUDA_SLUGNAME:
      return EXAM_FUKUDA_FULLNAME;
    case EXAM_ADAMS_SLUGNAME:
      return EXAM_ADAMS_FULLNAME;
    case EXAM_ROMBERG_SLUGNAME:
      return EXAM_ROMBERG_FULLNAME;
    case EXAM_RATE_SLUGNAME:
      return EXAM_RATE_FULLNAME;
    case EXAM_ANAM_SLUGNAME:
      return EXAM_ANAM_FULLNAME;
    case EXAM_TINETTI_SLUGNAME:
      return EXAM_TINETTI_FULLNAME;
    case EXAM_ELICOIDALE_SLUGNAME:
      return EXAM_ELICOIDALE_FULLNAME;
  }
};

export const extractExamTypeInfo = (type: string): { color: string } => {
  let color = "gray";
  switch (type) {
    case EXAM_4PHOTOS_SLUGNAME:
      color = "geekblue";
      break;
    case EXAM_AAII_SLUGNAME:
      color = "volcano";
      break;
    case EXAM_VISION_SLUGNAME:
      color = "cyan";
      break;
    case EXAM_MAGNO_SLUGNAME:
      color = "green";
      break;
    case EXAM_PODO_SLUGNAME:
      color = "magenta";
      break;
    case EXAM_PODO_STIM_SLUGNAME:
      color = "magenta";
      break;

    case EXAM_BALANCE_SLUGNAME:
      color = "purple";
      break;

    case EXAM_HEAD_SLUGNAME:
      color = "#fc03d05f";
      break;

    case EXAM_FUKUDA_SLUGNAME:
      color = "orange";
      break;

    case EXAM_ADAMS_SLUGNAME:
      color = "blue";
      break;

    case EXAM_ROMBERG_SLUGNAME:
      color = "pink";
      break;

    case EXAM_RATE_SLUGNAME:
      color = "#ab9b84";
      break;

    case EXAM_ANAM_SLUGNAME:
      color = "#508871";
      break;

    case EXAM_TINETTI_SLUGNAME:
      color = "#B5B3F1";
      break;

    case EXAM_ELICOIDALE_SLUGNAME:
      color = "yellow";
      break;
  }

  return { color: color };
};
